import { FC, ReactNode } from 'react';

import {
  flexbox,
  FlexboxProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system';

import theme from 'modules/Theme';
import styled from 'modules/Theme/styled-components';

import Box from '../Box';
import IconInfo from '../Icons/IconInfo';
import Text from '../Text';
import { checkTaxForRectificationCode } from './checkTaxCode';
import HasSpecificTaxAuthorityValidationsText from './hasSpecificTaxAuthorityValidationsText';

export enum BaiStatus {
  PRESENTED_ERRORS = 'PRESENTED_ERRORS',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}
interface Props extends FlexboxProps, SpaceProps, TypographyProps {
  code?: string;
  extraCode?: string | number;
  iconSize?: number;
  isPartial?: boolean;
  message: string | ReactNode;
  type?: BaiStatus;
}

const bgColors: Record<BaiStatus, string> = {
  [BaiStatus.PRESENTED_ERRORS]: theme.colors.warningBackground,
  [BaiStatus.PENDING]: theme.colors.auxiliary100A30,
  [BaiStatus.REJECTED]: theme.colors.errorBackground,
};

const colors: Record<BaiStatus, string> = {
  [BaiStatus.PRESENTED_ERRORS]: theme.colors.rejected,
  [BaiStatus.PENDING]: theme.colors.gray800,
  [BaiStatus.REJECTED]: theme.colors.rejected,
};

const StyledBaiStatus = styled(Box)`
  ${flexbox}
  ${space}
  ${typography}
`;

const DocumentBaiError: FC<Props> = ({
  code,
  extraCode,
  iconSize = 20,
  isPartial,
  message,
  type = BaiStatus.PRESENTED_ERRORS,
  ...rest
}) => {
  const backgroundColor = bgColors[type];
  const color = colors[type];
  const shoudRenderSpecificText =
    code && checkTaxForRectificationCode(code, extraCode);
  return (
    <StyledBaiStatus
      backgroundColor={backgroundColor}
      columnGap="8px"
      display="grid"
      gridTemplateColumns={`${iconSize}px 1fr}`}
      marginBottom="2px"
      tag="li"
      {...rest}
    >
      <IconInfo color={color} size={iconSize} />
      <Text color={color} fontSize="inherit" lineHeight="inherit" tag="span">
        {shoudRenderSpecificText ? (
          <HasSpecificTaxAuthorityValidationsText
            code={code}
            extraCode={extraCode}
            isPartial={isPartial}
          />
        ) : (
          <>{message}</>
        )}
      </Text>
    </StyledBaiStatus>
  );
};

StyledBaiStatus.defaultProps = {
  fontSize: 16,
  lineHeight: 24,
  padding: '8px 16px 8px',
};

export default DocumentBaiError;
